/* eslint-disable @typescript-eslint/no-explicit-any */

import { FC, useEffect, useState } from 'react';
import { Detalle } from '@/types/dashboard/RoRoPage';

import DetallesTable from './DetallesTable';

type DetalleProps = {
  detalles?: Detalle[] | null;
  isLoading?: boolean;
};

const DetallesComponent: FC<DetalleProps> = ({ detalles, isLoading }) => {
  const [data, setData] = useState<any[]>();

  useEffect(() => {
    if (detalles) {
      setData(
        detalles?.map((item) => ({
          ...item,
          fechaDescarga: new Date(item.fechaDescarga),
          fechaRegistro: new Date(item.fechaRegistro),
        }))
      );
    }
    if (!detalles) {
      setData([]);
    }
  }, [detalles]);

  return <DetallesTable data={data} isLoading={isLoading} />;
};

export default DetallesComponent;
